import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../../hooks/useTheme';

export interface PaletteSwatchProps {
  color: string;
  size?: number;
  isSelected?: boolean;
  onPress?: () => void;
  onLongPress?: () => void;
  onRemove?: () => void;
  showHex?: boolean;
}

const DEFAULT_SIZE = 56;

const PaletteSwatch: React.FC<PaletteSwatchProps> = ({
  color,
  size = DEFAULT_SIZE,
  isSelected = false,
  onPress,
  onLongPress,
  onRemove,
  showHex = true,
}) => {
  const { colors } = useTheme();

  return (
    <TouchableOpacity
      style={[
        styles.swatch,
        {
          width: size,
          height: size,
          backgroundColor: color,
          borderColor: isSelected ? colors.primary : 'transparent',
          borderWidth: isSelected ? 3 : 0,
        },
      ]}
      onPress={onPress}
      onLongPress={onLongPress}
      activeOpacity={0.8}
      accessibilityLabel={`Color ${color}`}
      accessibilityRole="button"
    >
      {isSelected && (
        <View style={styles.selectedIndicator}>
          <Ionicons name="checkmark" size={12} color="white" />
        </View>
      )}
      {onRemove && (
        <TouchableOpacity
          style={styles.removeButton}
          onPress={onRemove}
          accessibilityLabel="Remove color"
        >
          <Ionicons name="close" size={10} color="white" />
        </TouchableOpacity>
      )}
      {showHex && (
        <Text style={styles.hexText} numberOfLines={1}>
          {color}
        </Text>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  swatch: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  selectedIndicator: {
    position: 'absolute',
    top: 4,
    left: 4,
    width: 16,
    height: 16,
    borderRadius: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  removeButton: {
    position: 'absolute',
    top: 4,
    right: 4,
    width: 16,
    height: 16,
    borderRadius: 0,
    backgroundColor: 'rgba(0,0,0,0.65)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hexText: {
    position: 'absolute',
    bottom: 4,
    fontSize: 9,
    fontWeight: '600',
    color: '#FFFFFF',
    backgroundColor: 'rgba(0,0,0,0.6)',
    paddingHorizontal: 3,
    paddingVertical: 1,
    borderRadius: 3,
    overflow: 'hidden',
  },
});

export default PaletteSwatch;
